import { render } from "./header.vue?vue&type=template&id=0b4f1665"
import script from "./header.vue?vue&type=script&lang=js"
export * from "./header.vue?vue&type=script&lang=js"

import "./header.vue?vue&type=style&index=0&id=0b4f1665&lang=scss"
script.render = render

export default script